export default __webpack_public_path__ + "static/media/RapidFire.84b35293.svg";